import React, { Fragment } from "react";
import "./CardButton.scss"
import Icon from "../Icon/Icon";
import { useNavigate } from "react-router-dom";

const CardButton = ({ icon, title, subtitle, type, classNames, onClick, children }) => {
    const navigate = useNavigate()
const handleBalanceClick = () => {
    navigate('/withdrawals');
  };
    return (
        <div className={`card-button p-relative d-flex f-column bg-red-pink ${type ? type : ''} ${classNames}`} onClick={() => onClick()}>
            <div className="d-flex aic jcc">
                <div className="balance-button" onClick={handleBalanceClick}>
                    {title && <p className={`fs-sm2 fg-white fw-medium-bold mb-0 ${icon ? 'mt-8' : 'mt-0'}`}>{title}</p>}
                    {subtitle && <p className="subtitle fg-white d-flex aic my-0">
                        <span>{subtitle}</span>
                        <Icon className={"mt-4"} alias={"chevron-right"} color='#FFF' width={16} type="dark" />
                    </p>}
                </div >
                {icon && <div className="icon-container ml-auto">
                    {icon}
                </div>}
            </div>

            {children && <div className="d-flex f-column">
                <hr className="my-16" style={{ opacit: 0.24 }} />
                {children}
            </div>}
        </div>
    )
}

export default CardButton